import { j as m } from "../../../node_modules/react/jsx-runtime.js";
import { memo as t } from "react";
import { clsx as i } from "../../../node_modules/clsx/dist/clsx.m.js";
import b from "./Label.module.scss.js";
const p = ({ name: e, htmlFor: l, children: r, disabled: a, className: o, ...s }) => /* @__PURE__ */ m.jsxs(
  "label",
  {
    htmlFor: l,
    className: i(b.label, o),
    "aria-disabled": a,
    ...s,
    children: [
      e,
      r
    ]
  }
), d = t(p);
export {
  d as default
};
//# sourceMappingURL=Label.js.map
